import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import Box from '@material-ui/core/Box'
import MuiTabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'
import useTranslation from 'hooks/useTranslations'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const Tabs = () => {
  const classes = useStyles()
  const location = useLocation()

  const activeTab = useMemo(() => {
    if (location.pathname.includes('vendors/invitations')) return 1
    return 0
  }, [location.pathname])

  const t = useTranslation()

  return (
    <div className={classes.root}>
      <MuiTabs
        className={classes.tabs}
        value={activeTab}
        aria-label="Vendors tabs"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        classes={{
          indicator: classes.indicator,
        }}
      >
        <Tab
          className={classes.tab}
          label={t('tab:my-providers')}
          disableRipple
          {...a11yProps(0)}
          component={RouterLink}
          to={'/app/vendors'}
        />
        <Tab
          className={classes.tab}
          label={t('tab:pendings')}
          disableRipple
          {...a11yProps(1)}
          component={RouterLink}
          to={'/app/vendors/invitations'}
        />
      </MuiTabs>
      <TabPanel value={activeTab} index={0}>
        {/* Mis proveedores */}
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        {/* Pendientes */}
      </TabPanel>
    </div>
  )
}

export default Tabs
